import React, { Component } from "react";
import PropTypes from "prop-types";
import * as ReactTable from "reactabular-table";
import classNames from "classnames";
import { isEmpty, forEach, isEqual } from "@utils/lodash";

// eslint-disable-next-line react/jsx-props-no-spreading
const RowWrapper = props => <tr {...props} />;
RowWrapper.shouldComponentUpdate = () => true;

class CoreTable extends Component {
	shouldComponentUpdate = ({ columns, data, sortedColumn, rowKey, asc }) => {
		const lastProps = this.props;

		return (
			!isEqual(columns, lastProps.columns) ||
			!isEqual(data, lastProps.data) ||
			!isEqual(sortedColumn, lastProps.sortedColumn) ||
			!isEqual(rowKey, lastProps.rowKey) ||
			!isEqual(asc, lastProps.asc)
		);
	};

	getColumns = () => {
		const { columns, sortedColumn, asc } = this.props;

		const newColumns = [];

		// Add sortable class to each column if there
		// it has a sortable=true property from column definition
		forEach(columns, item => {
			const column = { ...item };
			const { header } = column;

			if (header === undefined || !header.sortable) {
				newColumns.push(column);
				return;
			}

			if (header.props === undefined) {
				column.header.props = { className: "sortable" };
			} else {
				const { className } = header.props;
				column.header.props.className = `${className === undefined ? "" : `${className} `}sortable`;
			}

			// Attach the proper callback
			column.header.props.onClick = this.onSortColumn.bind(null, column.property);

			// if there is already defined a sorted column,
			// process the proper column with asc/desc identifier
			if (
				sortedColumn === undefined ||
				asc === undefined ||
				sortedColumn !== column.property
			) {
				newColumns.push(column);
				return;
			}

			let processedClassName = header.props.className;

			processedClassName = classNames(
				...this.convertClassStringIntoObject(processedClassName),
				{
					asc,
					desc: !asc,
				},
			);

			column.header.props.className = processedClassName;
			newColumns.push(column);
		});

		return newColumns;
	};

	onSortColumn = (property, event) => {
		const { onSortColumn } = this.props;

		if (onSortColumn === undefined && onSortColumn instanceof Function) {
			onSortColumn(property, event);
		}
	};

	convertClassStringIntoObject = classString => {
		const headerClassList = {};

		// convert currect class list to keyValue object
		classString.split(" ").forEach(value => {
			headerClassList[value] = true;
		});

		return headerClassList;
	};

	render() {
		const { className, data, rowKey, onRow, hardRendered, isReport } = this.props;

		return (
			<ReactTable.Provider
				className={classNames("table", className, { empty: isEmpty(data) })}
				columns={this.getColumns()}
				renderers={
					hardRendered
						? {
								body: {
									row: RowWrapper,
								},
							}
						: undefined
				}
			>
				<ReactTable.Header className={isReport ? "report-header" : ""} />
				<ReactTable.Body
					rows={data}
					rowKey={rowKey}
					onRow={onRow}
				/>
			</ReactTable.Provider>
		);
	}
}

CoreTable.propTypes = {
	columns: PropTypes.array.isRequired,
	data: PropTypes.array,
	className: PropTypes.string,
	sortedColumn: PropTypes.string,
	rowKey: PropTypes.string,
	asc: PropTypes.bool,
	onSortColumn: PropTypes.func,
	onRow: PropTypes.func,
	hardRendered: PropTypes.bool,
	isReport: PropTypes.bool,
};

CoreTable.defaultProps = {
	data: [],
	className: undefined,
	sortedColumn: "Date",
	rowKey: "Id",
	asc: false,
	hardRendered: false,
	onSortColumn: null,
	onRow: () => undefined,
	isReport: false,
};

export default CoreTable;
